import { render, staticRenderFns } from "./allInfo.vue?vue&type=template&id=e55b3594&scoped=true"
import script from "./allInfo.vue?vue&type=script&lang=js"
export * from "./allInfo.vue?vue&type=script&lang=js"
import style0 from "./allInfo.vue?vue&type=style&index=0&id=e55b3594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55b3594",
  null
  
)

export default component.exports